import React, { Component } from 'react'
import { Row } from "antd"
import { observer, inject } from "mobx-react"
import styled from 'styled-components'
import overviewIcon from "app/styles/images/sp/overview-selected.svg"

const BalanceWrap = styled.div`
  width: 100%;
  height: 98px;
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const BalanceCon = styled.div`
  margin-left: 24px;
  .title {
    color: #333;
    font-size: 14px;
  }
  .current-balance {
    font-size: 36px;
    color: #286CAC;
  } 
`

@inject("store") @observer
export default class Balance extends Component {
  componentDidMount() {
    this.props.store.getBalance()
  }
  render() {
    const { total } = this.props.store
    return (
      <div>
        <h2 className="page-title"><img alt="" src={overviewIcon} />剩余份数</h2>
        <Row className="dashboard-chart-list">
          <BalanceWrap>
            <BalanceCon>
              <span className="title">当前账户剩余份数：</span>
              <span className="current-balance">{total}</span>
            </BalanceCon>
          </BalanceWrap>
        </Row>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/dashboard/containers/Balance.js